import { Link, Outlet, useLocation } from 'react-router-dom';

function tabClass(isActive) {
  return [
    'inline-block px-4 py-3 text-sm font-medium border-b-2 transition-colors',
    isActive
      ? 'border-primary text-foreground'
      : 'border-transparent text-muted-foreground hover:text-foreground hover:border-border',
  ].join(' ');
}

export default function StreamLayout() {
  const { pathname } = useLocation();
  const isMachinesTab =
    pathname === '/stream' || pathname.startsWith('/stream/machines');
  const isFleetTab = pathname.startsWith('/stream/erp-fleet');
  const isTypesTab = pathname.startsWith('/stream/machine-types');

  // Lives inside ChentronixLayout's content area (100vh, overflow-auto): fill it
  // and let the body scroll, so the HMI Studio (h-full) gets a bounded height.
  return (
    <div className="h-full min-h-0 flex flex-col bg-background text-foreground">
      <header className="border-b border-border px-4 md:px-8 pt-6 shrink-0">
        <h1 className="text-xl font-semibold text-foreground">Sim &amp; HMI console</h1>
        <p className="text-xs text-muted-foreground mt-1">Machine types, stream fields &amp; HMI Studio</p>
        <nav className="flex flex-wrap gap-1 mt-4" aria-label="Stream sections">
          <Link to="/stream" className={tabClass(isMachinesTab)}>
            Machines
          </Link>
          <Link to="/stream/erp-fleet" className={tabClass(isFleetTab)}>
            Fleet &amp; ERP types
          </Link>
          <Link to="/stream/machine-types" className={tabClass(isTypesTab)}>
            Machine type definitions
          </Link>
        </nav>
      </header>
      <main className="flex-1 min-h-0 overflow-auto">
        <Outlet />
      </main>
    </div>
  );
}
